module.exports = __webpack_public_path__ + "static/media/close.1dea6b77.svg";